<template>
  <div>
    <div class="position-relative">
      <section class="section section-sm bg-custom-bg-color" style="margin-top: 90px">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 col-sm-12 bg-white p-4 rounded-3">
              <ListDataLoadingWidget :data="news_list">
                <template v-slot:default="props">
                  <NewsItem :item="props.item"></NewsItem>
                  <div class="mt-3"></div>
                </template>
              </ListDataLoadingWidget>
              <div class='text-right'>
                <router-link :to="{name: 'news'}">
                  <base-button tag="p" class="bg-main-color border-0 text-white">
                    查看更多
                  </base-button>
                </router-link>
              </div>
            </div>
            <div style="margin-left: 30px"></div>
            <div class="col-lg col-sm-12 bg-white p-2 rounded-3">

              <h4 class="text-main-color font-weight-500 ">熱門排行</h4>


              <ListDataLoadingWidget :data="top_rank_list">
                <template v-slot:default="props">
                  <RankItem :index="props.index + 1" :item="props.item"></RankItem>
                  <div class="mt-3"></div>
                </template>
              </ListDataLoadingWidget>

              <!--              <div v-for="(item,index) in top_rank_list" :key="index">-->
              <!--                <RankItem :index=index+1 :item="item"></RankItem>-->
              <!--                <div class="mt-3"></div>-->
              <!--              </div>-->
              <div class="mt-2"></div>
              <div class='text-right'>
                <router-link :to="{name: 'top_rank'}">
                  <base-button tag="p" class="bg-main-color border-0 text-white">
                    查看更多
                  </base-button>
                </router-link>
              </div>

            </div>
          </div>
        </div>
      </section>

      <section class="section section-sm bg-custom-bg-color">
        <div class="container p-0">
          <div class="bg-white p-3 rounded-3">
            <div class="">
              <h2 class="display-3 text-custom-text ">品牌系列</h2>
            </div>
            <div class="mt-3"></div>
            <div v-if="band_list === null || band_list === undefined" class="loading" style="height: 206px">
              <b-spinner label="Loading..."></b-spinner>
            </div>
            <BandGlide v-else :band_list="band_list.items"/>
            <div class="mt-3"></div>
            <div class='text-right'>
              <router-link :to="{name: 'brand'}">
                <base-button tag="p" class="bg-main-color border-0 text-white">
                  查看更多
                </base-button>
              </router-link>
            </div>
          </div>
        </div>
      </section>

      <section class="section section-sm bg-custom-bg-color">
        <div class="container p-0">
          <div class="bg-white p-3 rounded-3">
            <div class="">
              <h2 class="display-3 text-custom-text ">最新訂單</h2>
            </div>
            <div class="mt-3"></div>
            <div v-if="latest_list === null || latest_list === undefined" class="loading" style="height: 304px">
              <b-spinner label="Loading..."></b-spinner>
            </div>
            <div v-else-if="latest_list.items.length === 0" class="text-main-color font-weight-500 text-center font-size-16 py-4">
              目前沒有型錄
            </div>
            <CatalogGlide v-else :list="latest_list.items"/>
            <div class="mt-3"></div>
            <div class='text-right'>
              <router-link :to="{name: 'latest'}">
                <base-button tag="p" class="bg-main-color border-0 text-white">
                  查看更多
                </base-button>
              </router-link>
            </div>
          </div>
        </div>
      </section>

      <section class="section section-sm bg-custom-bg-color">
        <div class="container p-0">
          <div class="bg-white p-3 rounded-3">
            <div class="">
              <h2 class="display-3 text-custom-text ">即將結單</h2>
            </div>
            <div class="mt-3"></div>
            <div v-if="coming_to_end_list === null || coming_to_end_list === undefined" class="loading"
                 style="height: 304px">
              <b-spinner label="Loading..."></b-spinner>
            </div>
            <div v-else-if="coming_to_end_list.items.length === 0" class="text-main-color font-weight-500 text-center font-size-16 py-4">
              目前沒有即將結單的型錄
            </div>
            <CatalogGlide v-else :list="coming_to_end_list.items"/>
            <div class="mt-3"></div>
            <div class='text-right'>
              <router-link :to="{name: 'closing_soon'}">
                <base-button tag="p" class="bg-main-color border-0 text-white">
                  查看更多
                </base-button>
              </router-link>
            </div>
          </div>
        </div>
      </section>

      <section class="section section-sm bg-custom-bg-color">
        <div class="container p-0">
          <div class="bg-white p-3 rounded-3">
            <div class="">
              <h2 class="display-3 text-custom-text ">您感興趣</h2>
            </div>
            <div class="mt-3"></div>
            <div v-if="interest_list === null || interest_list === undefined" class="loading" style="height: 304px">
              <b-spinner label="Loading..."></b-spinner>
            </div>
            <div v-else-if="interest_list.items.length === 0" class="text-main-color font-weight-500 text-center font-size-16 py-4">
              目前沒有您感興趣的型錄
            </div>
            <CatalogGlide v-else :list="interest_list.items"/>
            <div class="mt-3"></div>
            <div class='text-right'>
              <router-link :to="{name: 'interest'}">
                <base-button tag="p" class="bg-main-color border-0 text-white">
                  查看更多
                </base-button>
              </router-link>
            </div>
          </div>
        </div>
      </section>

    </div>

    <LoginNoticeDialog :show="showNoticeDialog" :message="noticeMessage" @confirm="onNoticeConfirm"/>
  </div>
</template>

<script>
import NewsItem from "@/views/components/elements/NewsItem";
import RankItem from "@/views/components/elements/RankItem";
import BandGlide from "@/views/components/elements/BandGlide";
import CatalogGlide from "@/views/components/elements/CatalogGlide";
import ListDataLoadingWidget from "@/layout/ListDataLoadingWidget";
import LoginNoticeDialog from "@/components/dialogs/LoginNoticeDialog.vue";

import {getMediaUrl, wait} from "@/util/helpers";
import {checkError} from "@/util/error_handler";
import * as Api from "@/util/http_api";

export default {
  name: "home",
  components: {
    NewsItem: NewsItem,
    RankItem: RankItem,
    BandGlide: BandGlide,
    CatalogGlide: CatalogGlide,
    ListDataLoadingWidget: ListDataLoadingWidget,
    LoginNoticeDialog,
  },
  props: {},
  data() {
    return {
      news_list: null,
      top_rank_list: null,
      band_list: null,
      latest_list: null,
      coming_to_end_list: null,
      interest_list: null,
      isLoading: true,
      items: [],
      is_show: false,
      showNoticeDialog: false,
      noticeMessage: '',
    };
  },
  watch: {
    $route(to, from) {
      console.log("$route to ", to) // 目的地
      console.log("$route from ", from) // 原地
    }
  },
  created() {
    this.init();
    this.checkLoginNotice();
  },
  methods: {
    // 只有剛登入完進來才檢查登入公告；一般重新整理首頁不會再跳出來
    async checkLoginNotice() {
      if (!this.$store.state.justLoggedIn) return;
      this.$store.commit('setJustLoggedIn', false);
      try {
        const message = await Api.getLoginNotice();
        if (message) {
          this.noticeMessage = message;
          this.showNoticeDialog = true;
        }
      } catch (e) {
        console.error('getLoginNotice error', e);
      }
    },
    onNoticeConfirm() {
      this.showNoticeDialog = false;
    },
    init() {
      this.getNews();
      this.getTopRanks();
      this.getBrands();
      this.getLatest();
      this.getComingToEnd();
      this.getInterestList();
    },
    async getNews() {
      try {
        this.news_list = await Api.getNews();
      } catch (e) {
        console.error(e);
      }
    },
    async getTopRanks() {
      try {
        this.top_rank_list = await Api.getTopRanks();
      } catch (e) {
        console.error(e);
      }
    },
    async getBrands() {
      try {
        this.band_list = await Api.getBrands();
      } catch (e) {
        console.error(e);
      }
    },
    async getLatest() {
      try {
        const result = await Api.getCatalogs({
          limit: 10,
          offset: 0,
          sorts: [['updated_at', 'DESC'], ['publish_date', 'DESC'], ['id', 'DESC']],
          filters: { 'final_date.start': new Date().toISOString() },
        });
        this.latest_list = result;
      } catch (e) {
        console.error(e);
      }
    },
    async getComingToEnd() {
      try {
        const result = await Api.getCatalogs({
          limit: 10,
          offset: 0,
          sorts: [['final_date', 'ASC'], ['id', 'DESC']],
          filters: { 'final_date.start': new Date().toISOString() },
          params: { closing_soon: 1 },
        });
        this.coming_to_end_list = result;
      } catch (e) {
        console.error(e);
      }
    },
    async getInterestList() {
      try {
        const result = await Api.getCatalogs({
          limit: 10,
          offset: 0,
          filters: { 'final_date.start': new Date().toISOString() },
        });
        this.interest_list = result;
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mb-150 {
  margin-bottom: 150px;
}
</style>
